import type { RouteRecordRaw } from 'vue-router';

export const organizationsRoute: RouteRecordRaw = {
  path: '/settings/organizations',
  name: 'Organizations',
  component: () => import('./pages/OrganizationsPage.vue'),
  meta: {
    title: 'Organizations',
    layout: 'main',
    // CLIENT users only receive their own organization from the API, so direct
    // URL access is harmless — the nav item itself is gated more strictly.
    authorize: ({ isGranted }) => isGranted('dt:core:organizations:list'),
  },
};

export const organizationRoute: RouteRecordRaw = {
  path: '/settings/organizations/:id',
  name: 'Organization',
  component: () => import('./pages/OrganizationPage.vue'),
  meta: {
    title: 'Organization',
    layout: 'main',
    // Same reasoning as the list: the API narrows a CLIENT caller to their own
    // organization and answers NotFound for anyone else's, so a guessed URL
    // discloses nothing.
    authorize: ({ isGranted }) => isGranted('dt:core:organizations:get'),
  },
};
